import type { StoryAuthorType } from "@/db/schema/story";

export const storyKeys = {
  all: ["stories"] as const,
  tray: () => [...storyKeys.all, "tray"] as const,
  author: (authorType: StoryAuthorType, authorId: string) =>
    [...storyKeys.all, "author", authorType, authorId] as const,
  viewers: (storyId: number) => [...storyKeys.all, "viewers", storyId] as const,
  highlights: (ownerType: StoryAuthorType, ownerId: string) =>
    [...storyKeys.all, "highlights", ownerType, ownerId] as const,
  highlightItems: (highlightId: number) =>
    [...storyKeys.all, "highlight-items", highlightId] as const,
  contributionQueue: (eventId: number) =>
    [...storyKeys.all, "contribution-queue", eventId] as const,
  myAuthorOptions: () => [...storyKeys.all, "my-author-options"] as const,
};
